// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cE-z","hovered":"dE-z","hoverImage":"eE-z","mainImage":"fE-z","imageNoBackground":"gE-z","fullSizeImage":"hE-z"};